import { useState, useEffect } from 'react';
import { img, imgURL } from '../../Config';
import Carousel from '../../Carousel/imageCarosel/ImageCarousel';
import moment from 'moment';
import Swal from 'sweetalert2';
import './EventDetails.css';
import { eventRegister, getAllDataWithFlag, getEventEvidence } from '../../../services/CommonService';
import { useParams, Link, useLocation } from 'react-router-dom';
import { Modal, Button, Form, Row, Col } from 'react-bootstrap';
import ReactPlayer from 'react-player';


const EventDetails = () => {
    const location = useLocation();
    const [eventDetails, setEventDetails] = useState({});
    const { id } = useParams(null);
    const [showModal, setShowModal] = useState(false);
    const [userData, setuserdata] = useState('');
    const [formData, setFormData] = useState({
        event_id: '', name: '', mobile: '', email: '', organisation: '', qualification: '', nature_of_current_duties: '', work_area: '', age: ''
    });
    const [errors, setErrors] = useState({});
    const isFutureDate = moment(eventDetails.event_date).isSameOrAfter(moment(), 'day');
    const [evidences, setEvidences] = useState([]);
    const [lookupData, setLookupData] = useState([]);
    const register = location?.state?.register;

    useEffect(() => {
        // Simulated API data (replace with real fetch call)
        const fetchData = async () => {
            const response = await getAllDataWithFlag(6);
            const eventData = response?.data?.event?.find((m) => (m.id == id));
            setEventDetails(eventData);
        };

        fetchData();
        setFormData({ ...formData, event_id: id });
        fetchEvidences();
        const lookup = JSON.parse(localStorage.getItem('lookup'));
        const getuserData = JSON.parse(localStorage.getItem('usercre'));
        setuserdata(getuserData);
        setLookupData(lookup);
    }, []);

    const fetchEvidences = async () => {
        try {
            const response = await getEventEvidence(id);
            setEvidences(response.data);
        } catch (err) {
            Swal.fire({
                title: "Error",
                text: err?.response?.data?.message || err?.message,
                icon: "error",
                confirmButtonText: "OK",
            });
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === "mobile") {
            if (/^\d{0,10}$/.test(value)) {
                setFormData((prev) => ({ ...prev, [name]: value }));
            }
            return;
        }

        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleOpenRegisterModal = () => {
        if (userData) {
            setFormData({
                name: userData.name || '',
                mobile: userData.phone || '',
                email: userData.email || '',
                age: userData.age || '',
                organisation: userData.organization || '',
                qualification: userData.qualification || '',
                nature_of_current_duties: userData.nature_of_current_duties || '',
                work_area: userData.work_area || '',
            });
        } else {
            // Reset if no user data
            setFormData({
                name: '',
                mobile: '',
                email: '',
                age: '',
                organisation: '',
                qualification: '',
                nature_of_current_duties: '',
                work_area: '',
            });
        }
        setShowModal(true);
    };

    const validateForm = () => {
        const newErrors = {};
        if (!formData.name) newErrors.name = 'Name is required';
        if (!formData.mobile || !/^[0-9]{10}$/.test(formData.mobile)) newErrors.mobile = 'A valid phone number is required';
        if (!formData.email || !/\S+@\S+\.\S+/.test(formData.email)) newErrors.email = 'A valid email is required';
        if (!formData.organisation) newErrors.organisation = 'Organisation is required';
        if (!formData.age || isNaN(formData.age)) newErrors.age = 'A valid age is required';
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) {
            Swal.fire({
                title: "Validation Error",
                icon: "error",
                text: "Please fix the validation errors before submitting.",
                confirmButtonText: "Ok",
            });
            return
        };
        setErrors({});
        if (!validateName(formData.name)) {
            Swal.fire({
                title: "Validation Error",
                icon: "error",
                text: "Invalid name. Only letters and spaces are allowed.",
                confirmButtonText: "Ok",
            });
            return
        } else if (!validateAge(formData.age)) {
            Swal.fire({
                title: "Validation Error",
                icon: "error",
                text: "Invalid age. Must be a number between 1 and 120.",
                confirmButtonText: "Ok",
            });
            return
        }

        try {
            formData.event_id = id;
            const response = await eventRegister(formData);
            if (response.status == 201) {
                Swal.fire({
                    title: "Success!",
                    text: "Registration successful.",
                    icon: "success",
                    confirmButtonText: "OK",
                });
                setShowModal(false);
                setFormData({
                    name: '', mobile: '', email: '', organisation: '', qualification: '', nature_of_current_duties: '', work_area: '', age: ''
                });
            }
        } catch (err) {
            Swal.fire({
                title: "Error!",
                text: (err?.response?.data?.errors?.name?.[0] ||
                    err?.response?.data?.errors?.email?.[0] || 
                    err?.response?.data?.errors?.mobile?.[0]
                    || err?.response?.data?.errors?.qualification?.[0]
                    || err?.message),
                icon: "error",
                confirmButtonText: "OK",
            });
        }
    };
    if (!eventDetails) {
        return (
            <div className="text-center mt-5">
                <div className="spinner-border text-primary" role="status" />
            </div>
        );
    }

    function validateName(name) {
        const nameRegex = /^[a-zA-Z\s]+$/;
        return nameRegex.test(name);
    }

    function validateAge(age) {
        const parsedAge = parseInt(age, 10);
        return !isNaN(parsedAge) && parsedAge > 0 && parsedAge <= 120;
    }

    const dateFormat = (d) => {
        return d ? moment(d).format('DD-MM-YYYY') : 'N/A';
    };

    const banners = localStorage.getItem('banners') ? JSON.parse(localStorage.getItem('banners')) : [];
    const bannerItem = banners.length ? banners.find((r) => r.banner_type == 7) : {};

    return (
        <div>
            <div className="position-relative">
                {eventDetails?.banner ? (
                    <img
                        src={`${imgURL}event_banners/${eventDetails.banner}` || 'assets/images/bannerDefault.jpg'}
                        alt="Groundwater"
                        className="img-fluid w-100"
                        style={{ minHeight: '350px', maxHeight: '350px', objectFit: 'cover' }}
                        onError={(e) => {
                            e.target.onerror = null;
                            e.target.style.display = 'none';
                        }}
                    />
                ) : (
                    <div
                        className="w-100 h-100"
                        style={{
                            minHeight: '350px',
                            maxHeight: '350px',
                            backgroundColor: '#e9ecef',
                        }}
                    />
                )}
                <div className="container-fluid text-end z-1 position-absolute mt-3">
                    <Link to={'../events'}><button className='btn btn-sm btn-warning'><i className="bi bi-arrow-left me-1"></i>Back</button></Link>
                </div>
                <div className="position-absolute top-0 left-0 w-100 h-100 bg-dark" style={{ opacity: 0 }}></div>
                <div className="container position-relative" style={{ marginTop: '-65px' }}>
                    <div className="bg-white rounded-3 shadow p-4 banner_overlay ">
                        <h3 className="text-center mb-4 fw-bold text-truncate">{eventDetails.title}</h3>
                        <div className="text-center">
                            <div className='eventtheme_layout'> <span className="px-4 py-2  ">Theme: {eventDetails.theme}</span></div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Main Content */}
            <div className="container my-5" >
                <div className="row">
                    <div className="col-lg-8">
                        <h2 className="fw-bold mb-4">{eventDetails.title}</h2>
                        <p className="mb-3" dangerouslySetInnerHTML={{ __html: eventDetails.description }}>
                        </p>
                    </div>
                    {/* Sidebar */}
                    <div className="col-lg-4">
                        <div className="card mb-4 text-white" style={{ background: '#122B50' }}>
                            <div className="card-header border-0">
                                <h4 className="mb-0">Schedule</h4>
                            </div>
                            <div className="card-body">
                                <div className="d-flex align-items-center mb-3">
                                    <div className="bg-warning text-white rounded p-2 me-3">
                                        {/* <i className="fa fa-calendar fa-lg"></i> */}
                                        <img src='/assets/images/event-date.png' className='eventImgIcon' />
                                    </div>
                                    <div>
                                        <strong>{dateFormat(eventDetails.event_date) === dateFormat(eventDetails.event_end_date)
                                            ? dateFormat(eventDetails.event_date)
                                            : `${dateFormat(eventDetails.event_date)} to ${dateFormat(eventDetails.event_end_date)}`}</strong>
                                    </div>
                                </div>
                                <div className="d-flex align-items-center mb-3">
                                    <div className="bg-warning text-white rounded p-2 me-3">
                                        <img src='/assets/images/event-time.png' className='eventImgIcon' />
                                    </div>
                                    <div>
                                        <strong>{eventDetails.event_time} To {eventDetails.event_end_time}</strong>
                                    </div>
                                </div>
                                {eventDetails.meeting_place && <div className="d-flex align-items-center mb-3">
                                    <div className="bg-warning text-white rounded p-2 me-3">
                                        <img src='/assets/images/event-location.png' className='eventImgIcon' />
                                    </div>
                                    <div>
                                        <strong>{eventDetails.meeting_place}</strong>
                                    </div>
                                </div>}
                                {(eventDetails?.entry_type == 1) && <div className="d-flex align-items-center">
                                    <div className="bg-warning text-white text-center rounded me-3" style={{ padding: '12px 15px' }}>
                                        (<i className='fa-solid fa-inr'></i>)
                                    </div>
                                    <div>
                                        {eventDetails?.ticket_price}
                                    </div>
                                </div>}
                            </div>
                        </div>
                        {register && (
                            <div className="text-center mt-3">
                                {/* <button className="btn btn-warning w-100" onClick={() => setShowModal(true)}>Register Now</button> */}
                                <button className="btn btn-warning w-100" onClick={handleOpenRegisterModal}>
                                    Register Now
                                </button>
                            </div>
                        )}
                    </div>
                </div>

                {(evidences?.length > 0) && (<div className="bg-light p-4 rounded-3 my-4">
                    <h3 className="fw-bold mb-3">Key Highlights</h3>
                    <div className="row">
                        {evidences?.map((evidence, index) => (
                            <div className="col-md-4 mb-4" key={evidence.id || index}>
                                <div className="card h-100">
                                    {(evidence.type == 2 && evidence.link == 2) ? (<div className="ratio ratio-16x9">
                                        <ReactPlayer
                                            url={evidence.media_path}
                                            controls
                                            width="100%"
                                            height="100%"
                                            config={{
                                                file: {
                                                    attributes: {
                                                        style: { objectFit: 'cover' }
                                                    }
                                                }
                                            }}
                                        />
                                    </div>) : (evidence.type == 1 && evidence.link == 1) ? (
                                        <div className="ratio ratio-16x9">
                                            <img
                                                src={imgURL + evidence.media_path}
                                                className="card-img-top"
                                                alt={`Event Evidence ${index + 1}`}
                                                style={{ height: '200px', objectFit: 'cover' }}
                                            /> </div>
                                    ) : (
                                        // <div className="ratio ratio-16x9">
                                        <img
                                            src={evidence.media_path}
                                            className="card-img-top"
                                            alt={`Event Evidence ${index + 1}`}
                                            style={{ height: '200px', objectFit: 'cover' }}
                                        />
                                        // </div>
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>)}

                {(eventDetails?.organization_details?.length > 0) && (<>
                    <h3 className="fw-bold mb-4">Speakers</h3>
                    <div className="row">
                        {eventDetails?.organization_details?.map((m) => (
                            <div key={m.id} className='card col-8'>
                                <table className='table '>
                                    <thead >
                                        <tr>
                                            <th >Speakers Name</th>
                                            <th>Organisation Name</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>{m.name}</td>
                                            <td>{m.organisation}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        ))}
                    </div>
                </>)
                }
            </div>

            <Modal className='event-register' show={showModal} onHide={() => setShowModal(false)}>
                <Modal.Header className='event-header' closeButton>
                    <Modal.Title>Event Registration</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <h6><b>Event Name:- </b>{eventDetails.title}</h6>
                    <Form onSubmit={handleSubmit}>
                        <Row>
                            <Col md={6}>
                                <Form.Group >
                                    <Form.Label className='required event-register-font'>Name of Participant</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="name"
                                        value={formData.name}
                                        onChange={handleChange}
                                        isInvalid={!!errors.name}
                                    />
                                    <Form.Control.Feedback type="invalid">{errors.name}</Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group >
                                    <Form.Label className='required event-register-font'>Phone Number</Form.Label>
                                    <Form.Control
                                        type="number"
                                        name="mobile"
                                        className="py-2"
                                        value={formData.mobile}
                                        onChange={handleChange}
                                        isInvalid={!!errors.mobile}
                                    />
                                    <Form.Control.Feedback type="invalid">{errors.mobile}</Form.Control.Feedback>
                                </Form.Group>
                            </Col>

                            <Col md={6}>
                                <Form.Group >
                                    <Form.Label className='required event-register-font'>Email</Form.Label>
                                    <Form.Control
                                        type="email"
                                        name="email"
                                        className="py-2"
                                        value={formData.email}
                                        onChange={handleChange}
                                        isInvalid={!!errors.email}
                                    />
                                    <Form.Control.Feedback type="invalid">{errors.email}</Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group >
                                    <Form.Label className='event-register-font required'>Age</Form.Label>
                                    <Form.Control
                                        type="number"
                                        name="age"
                                        className="py-2"
                                        value={formData.age}
                                        onChange={handleChange}
                                        isInvalid={!!errors.age}
                                    />
                                    <Form.Control.Feedback type="invalid">{errors.age}</Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group >
                                    <Form.Label className='required event-register-font'>Organisation</Form.Label>
                                    <Form.Control
                                        as="textarea"
                                        name="organisation"
                                        rows={2}
                                        value={formData.organisation}
                                        onChange={handleChange}
                                        isInvalid={!!errors.organisation}
                                        maxLength={250}
                                    />
                                    <Form.Control.Feedback type="invalid">{errors.organisation}</Form.Control.Feedback>
                                </Form.Group>
                            </Col>

                            <Col md={6}>
                                <Form.Group >
                                    <Form.Label className='event-register-font'>Qualification</Form.Label>
                                    <Form.Control
                                        as="textarea"
                                        rows={2}
                                        name="qualification"
                                        value={formData.qualification}
                                        onChange={handleChange}
                                        maxLength={50}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group >
                                    <Form.Label className='event-register-font'>Nature of Current Duties</Form.Label>
                                    <Form.Control
                                        as="textarea"
                                        rows={2}
                                        name="nature_of_current_duties"
                                        value={formData.nature_of_current_duties}
                                        onChange={handleChange}
                                        maxLength={100}
                                    />
                                </Form.Group>
                            </Col>

                            <Col md={6}>
                                <Form.Group >
                                    <Form.Label className='event-register-font'>Work Area</Form.Label>
                                    <Form.Control
                                        as="textarea"
                                        rows={2}
                                        name="work_area"
                                        value={formData.work_area}
                                        onChange={handleChange}
                                        maxLength={100}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Button type="submit" variant="primary" className="w-100">Register</Button>
                    </Form>

                </Modal.Body>
            </Modal>

        </div>
    );
};

export default EventDetails;